import { create } from 'zustand';

interface ISearchStore {
  isActive: boolean;
  setActive: () => void;
  setInactive: () => void;
}

export const useSearchStore = create<ISearchStore>(set => ({
  isActive: false,
  setActive: () => set({ isActive: true }),
  setInactive: () => set({ isActive: false }),
}));
